const $functions = require('./functions');

class Fraction{
	constructor(num_, den_=1){
		let den = den_, num = num_;
		 if(num_ instanceof Object){
			num = num_.num;
			den = num_.den;
		}else if(typeof num ==='string' && num.includes('/')){
			let parts = num.split('/');
			num = parts[0];
			den = parts[1];
		}

		if(den <= 0 || num==undefined){
			throw new Error("Invalid parameters numerator:"+num+" denominator: "+den);
		}else{
			this.num = num;
			this.den = den;
			this.isFraction = true;
			this.original_params = {num: num, den: den};
		}
	}

	get corrected(){
		return new Fraction(parseInt(this.num), parseInt(this.den));
	}
	set denom(nbre){
		this.num = (nbre / this.den) * this.num;
		this.den = nbre;
	}
	get floatVal(){
		let num = Number(this.num), den = Number(this.den);
		return (parseFloat(this.num || 0) / parseFloat(den || 1)).toFixed(4);
	}
	get pgcd(){
		if(Number(this.num) != this.num || Number(this.den) != this.den){
			return 1;
		}
		let x = Math.abs(this.num), y = Math.abs(this.den);
		while(y) {
			var t = y;
			y = x % y;
			x = t;
		}
		return x;
	}
	get isSimplificated(){
		return  Number(this.num) != this.num || Number(this.den) != this.den || this.pgcd == 1;
	}
	get intVal(){
		return parseInt(this.num / this.den);
	}
	get inverse(){
		return new Fraction(this.den, this.num);
	}
	get original(){
		new Fraction(this.original_params);
	}
	get simplificated(){
		if(Number(this.den) != this.den || Number(this.num) != this.num){
			return this; //"8<span class='cross-fraction'>X</span><span class='ppcm-multiple'>3</span>"
		}
		let pgcd = this.pgcd;
		return this.den == pgcd ? this.num / this.den : new Fraction(this.num / pgcd, this.den / pgcd);
	}
	get simplification(){
		if(this.pgcd == 1){
			return this;
		}
		let m = 'x' + this.pgcd;
		// return $functions.tag('fraction-component','',{':fraction':"{den:\""+this.den/this.pgcd + m+",num:\""+this.num/this.pgcd + m+"}",':simplification':true});
		return new Fraction({num: this.num / this.pgcd + m, den: this.den / this.pgcd + m} );
	}

	get intFractionNotation(){
		let int = parseInt(this.num / this.den);
		if(int > 0){
			let f = new Fraction({num: this.simplificated.num % this.simplificated.den, den: this.simplificated.den});
			return $functions.tag(
				'span',
				$functions.read_notation(int) + ' ' + $functions.tag(
					'fraction-component', '',
					{":fraction": "{den:" + f.simplificated.den + ",num:" + f.simplificated.num + "}"}
				)
			);
		}else{
			return this.simplificated.toString();
		}
	}
	get mixed_to_fraction_operation(){
		if(this.intVal >= 1){
			let fract = this.simplificated;
			if(this.simplificated == this.intVal){
				return new Fraction({num: this.intVal, den: 1});
			}
			return new Fraction({
				num: `(${fract.intVal} x ${fract.den}) + ${fract.num % fract.den}`,
				den: fract.den,
			});
		}else{
			return this;
		}
	}
	get fractionOfMixed() {
		return new Fraction({num: this.simplificated.num % this.simplificated.den, den: this.simplificated.den});
	}

	equal_to(f, strict=false){
		let fract = new Fraction(f);
		return strict?
			fract.num == this.num && fract.den == this.den:
			fract.num / this.num == fract.den / this.den;
	}
	get_reduced(ppcm){
		let m = ppcm / this.den
		return new Fraction({num: this.num * m, den: this.den * m});
	}
	reduction_to(ppcm){
		let m = $functions.tag('span', 'X', { class: "cross-reduction" }) + $functions.tag('span', (ppcm / this.den), { class: "ppcm" });
		return new Fraction({
			num: this.num + m,
			den: this.den + m,
		})
	}

	toString() {
		return $functions.tag('fraction-component', '', {':fraction': "{den:\"" + this.den + "\",num:\"" + this.num + "\"}"});
	}

	string(){
		return `${this.num}/${this.den}`;
		return this.num + "/" + this.den;
	}
}

module.exports = Fraction;